module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content close-date-picker reports city_collection_reports_pop report_generation_progress_main",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "general_reports_btn",
    class: _vm.addButtonClass
  }, [_c('button', {
    staticClass: "btn gradientbt filter",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#filtertoogle"
    }
  }, [_vm._v("\n                Apply Filter\n                    "), _c('span', {
    class: {
      'counter_filter': _vm.count
    }
  }, [_vm._v(_vm._s(_vm.count))])]), _vm._v(" "), _c('button', {
    staticClass: "btn gradientbt",
    on: {
      "click": _vm.refreshReportList
    }
  }, [_vm._v("\n                Refresh\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn gradientbt ml-5",
    on: {
      "click": _vm.gotoReportGeneration
    }
  }, [_vm._v("\n                Generate Reports\n            ")])]), _vm._v(" "), _c('v-server-table', {
    ref: "wardReportTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "c-pointer report_generation_progress"
        }, [(props.row.fileUrl == '') ? _c('a', {
          attrs: {
            "disabled": ""
          }
        }, [_vm._v("Report Generation In Progress.")]) : _vm._e(), _vm._v(" "), (props.row.fileUrl != '') ? _c('a', {
          staticClass: "fa fa-download",
          attrs: {
            "role": "button",
            "href": props.row.fileUrl,
            "target": "_blank"
          }
        }) : _vm._e()])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade model_modify_wrp",
    attrs: {
      "id": "filtertoogle",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h2', [_vm._v("Filters")]), _vm._v(" "), _c('button', {
    staticClass: "close clearButton",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("\n                        Clear All\n                    ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "main_select_wrp"
  }, [(this.adminCheck == 'superAdmin') ? _c('div', {
    staticClass: "flex selectwca_wrp "
  }, [_c('div', {
    staticClass: "multiselected"
  }, [_c('label', [_vm._v("Zone")]), _vm._v(" "), _c('multiselect', {
    key: _vm.areasList.length,
    attrs: {
      "track-by": "wardId",
      "label": "wardName",
      "placeholder": "Select Zone",
      "options": _vm.areasList,
      "multiple": "",
      "name": "wasteArea",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": ""
    },
    on: {
      "select": _vm.onCheckedFilter,
      "remove": _vm.onRemoveFilter
    },
    model: {
      value: (_vm.clearFilters.wasteCollectionArea.value),
      callback: function($$v) {
        _vm.$set(_vm.clearFilters.wasteCollectionArea, "value", $$v)
      },
      expression: "clearFilters.wasteCollectionArea.value"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (this.adminCheck !== 'superAdmin') ? _c('div', {
    staticClass: "flex selectwca_wrp main_select_wrp_houses"
  }, [_c('div', {
    staticClass: "multiselected"
  }, [_c('label', [_vm._v("Zone")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "track-by": "wardId",
      "label": "wardName",
      "placeholder": "Select Zone",
      "options": _vm.areasList,
      "multiple": "",
      "name": "wasteArea",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": ""
    },
    on: {
      "select": _vm.onCheckedFilter,
      "remove": _vm.onRemoveFilter
    },
    model: {
      value: (_vm.clearFilters.wasteCollectionArea.value),
      callback: function($$v) {
        _vm.$set(_vm.clearFilters.wasteCollectionArea, "value", $$v)
      },
      expression: "clearFilters.wasteCollectionArea.value"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), (_vm.isGenerateReport) ? _c('div', {}, [(_vm.isGenerateReport) ? _c('div', {}, [_c('div', {}, [_c('div', {}, [_c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('vue-form', {
    attrs: {
      "state": _vm.formstate
    }
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Generate Reports")]), _vm._v(" "), (_vm.reportLoading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader'), _vm._v(" "), _c('p', [_vm._v("Please wait, report generation is in progress.")])], 1) : _vm._e(), _vm._v(" "), (!_vm.reportLoading) ? _c('div', {
    staticClass: "col-sm-12 scroll_pop",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [(_vm.adminCheck == 'superAdmin') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cityId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wardReport.cityId),
      expression: "wardReport.cityId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "cityId",
      "disabled": _vm.isCityDisable
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.wardReport, "cityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.onCheckedCity($event.target.value)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select City Name")]), _vm._v(" "), _vm._l((_vm.citys), function(cityId) {
    return _c('option', {
      domProps: {
        "value": cityId.id
      }
    }, [_vm._v("\n                                                        " + _vm._s(cityId.name) + "\n                                                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cityId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.wardId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Zone")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wardReport.wardId),
      expression: "wardReport.wardId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "wardId"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.wardReport, "wardId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.onCheckedWard($event.target.value)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Zone")]), _vm._v(" "), _vm._l((_vm.areas), function(wards) {
    return _c('option', {
      domProps: {
        "value": wards.wardId
      }
    }, [_vm._v("\n                                                        " + _vm._s(wards.wardName) + "\n                                                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "wardId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "required-field",
    class: _vm.fieldClassName(_vm.formstate.date),
    staticStyle: {
      "min-height": "127px"
    },
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "date",
      "required": "",
      "lang": "en",
      "name": "date",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY",
      "not-after": _vm.disabledAfter
    },
    model: {
      value: (_vm.wardReport.date),
      callback: function($$v) {
        _vm.$set(_vm.wardReport, "date", $$v)
      },
      expression: "wardReport.date"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "date",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is a required field")])])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onModalClose
    }
  }, [_vm._v("\n                                        Cancel\n                                    ")]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.generateReport
    }
  }, [_vm._v("\n                                        Generate\n                                    ")])])], 1)])])])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-67a09354", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67a09354"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/wasteReports/ward_collection_reports.vue
// module id = 2332
// module chunks = 0